import { Box, useMantineTheme } from '@mantine/core';
import { ReactNode } from 'react';

export function DiscountsPageContent({ children }: { children: ReactNode }) {
    const theme = useMantineTheme();
    return (
        <Box p="md" sx={{ backgroundColor: theme.colors.gray[2], padding: theme.spacing.md, height: '100%' }}>
            {children}
        </Box>
    );
}
